<template>
  <div class="relative flex basis-full flex-col items-center text-center xl:max-w-[420px]">
    <h3 v-if="data?.title" class="mb-3 font-serif text-5xl font-bold text-blue lg:text-6xl">
      {{ data?.title }}
    </h3>
    <HeaderLine />
    <div
      v-if="data?.copy"
      :class="
        twMerge(
          'mt-7 font-sans text-base leading-snug lg:mt-12 lg:text-lg',
          useDarkMode ? 'text-white' : 'text-black',
        )
      "
      v-html="data?.copy"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'
import HeaderLine from '../atoms/Icons/HeaderLine.vue'
import { twMerge } from 'tailwind-merge'

export interface IFactsCard {
  title?: string
  copy?: string
}

interface Props {
  data: IFactsCard
}

defineProps<Props>()
const settings = inject<string[]>('settings', [])
const useDarkMode = computed(() => settings?.includes('dark_theme') ?? false)
</script>
